// extracted by mini-css-extract-plugin
export default {"container":"container__Es5E3lzC","image":"image__BFYOuly4","fallback":"fallback__QifnKfxy","logoName":"logoName__XHgpA0W1"};